<template>
    <section class="bg-white">
        <div class="container min-h-screen px-6 py-6 md:py-12 mx-auto lg:flex lg:items-center lg:gap-12">
            <div class="wf-ull lg:w-1/2">
                <p class="text-sm font-medium text-prime-color">Lỗi 404</p>
                <h1 class="mt-[12px] text-black text-2xl font-semibold md:text-3xl">Không tìm thấy trang</h1>
                <p class="mt-[12px] md:mt-4 text-gray-600">Xin lỗi, trang của bạn đang tìm kiếm không tồn tại. Dưới đây có thể là một số trang bạn quan tâm:</p>
                <div class="flex items-center mt-6 gap-x-3">
                    <button @click="goBack" class="flex items-center justify-center w-1/2 px-[8px] sm:px-6 py-[8px] text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto hover:bg-gray-100 hover:text-prime-color hover:!border-prime-color">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                        </svg>
                        <span class="w-fit">Quay lại</span>
                    </button>
                    <button @click="goToHome" class="w-1/2 px-[8px] sm:px-7 py-[8px] text-sm tracking-wide text-white transition-colors duration-200 bg-prime-color rounded-lg shrink-0 sm:w-auto hover:bg-red-700">
                        Trang chủ
                    </button>
                </div>
                <div class="mt-10 space-y-6">
                    <div>
                        <a href="/about" class="inline-flex items-center text-sm text-prime-color gap-x-2 hover:text-red-800 hover:underline">
                            <span>Về chúng tôi</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                            </svg>
                        </a>
                        <p class="mt-[8px] text-sm text-gray-500">Giới thiệu về HUET.</p>
                    </div>
                    <div>
                        <a href="news" class="inline-flex items-center text-sm text-prime-color gap-x-2 hover:text-red-800 hover:underline">
                            <span>Bản tin</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                            </svg>
                        </a>
                        <p class="mt-[8px] text-sm text-gray-500">Đọc các thông báo, sự kiện mới nhất.</p>
                    </div>
                    <div>
                        <a href="/contact" class="inline-flex items-center text-sm text-prime-color gap-x-2 hover:text-red-800 hover:underline">
                            <span>Liên hệ</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                            </svg>
                        </a>
                        <p class="mt-[8px] text-sm text-gray-500">HUET sẵn sàng hỗ trợ bạn.</p>
                    </div>
                </div>
            </div>
            
            <div class="relative w-full mt-12 lg:w-1/2 lg:mt-0">
                <img class="w-full max-w-lg lg:mx-auto" src="@/assets/img/error/404.svg" alt="">
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Error404",
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        goToHome() {
            this.$router.push({path: '/'});
        },
    }
}
</script>